import { type FC } from 'react';
import { Stack, Text } from '@mantine/core';
import { BankIdentity } from '~/entities/bank';
import { formatOrder, type PayoutRequisiteV2 } from '~/entities/payout';

interface RequisiteProps {
    requisiteV2: PayoutRequisiteV2 | undefined;
}

export const Requisite: FC<RequisiteProps> = ({ requisiteV2 }) => {
    const { card, sbp } = requisiteV2 ?? {};

    return (
        <Stack gap={2}>
            {card?.bankCode && <BankIdentity bankCode={card.bankCode} />}

            {card?.number && <Text size='sm'>{formatOrder.cardNumber(card.number)}</Text>}

            {sbp?.bankCode && <BankIdentity bankCode={sbp.bankCode} />}

            {sbp?.phoneNumber && <Text size='sm'>{formatOrder.phoneNumber(sbp.phoneNumber)}</Text>}
        </Stack>
    );
};
